import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";

import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Features from "@/components/site/Features";
import GamingHome from "@/components/site/GamingHome";
import Planes from "@/components/site/Planes";
import AppMobile from "@/components/site/AppMobile";
import NexaSmart from "@/components/site/NexaSmart";
import Cobertura from "@/components/site/Cobertura";
import Clientes from "@/components/site/Clientes";
import Contacto from "@/components/site/Contacto";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";
import Gaming from "@/pages/Gaming";
import GamingAdmin from "@/pages/GamingAdmin";
import { BasesCondiciones, Privacidad } from "@/pages/Legal";

const Home = () => (
  <div className="min-h-screen bg-white text-slate-900">
    <Navbar />
    <Hero />
    <Features />
    <Planes />
    <NexaSmart />
    <AppMobile />
    <Cobertura />
    <GamingHome />
    <Clientes />
    <Contacto />
    <Footer />
    <WhatsAppFab />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gaming" element={<Gaming />} />
          <Route path="/gaming/admin" element={<GamingAdmin />} />
          <Route path="/legal/bases" element={<BasesCondiciones />} />
          <Route path="/legal/privacidad" element={<Privacidad />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
